export class EventType {
    public static readonly ABORTION = new EventType(
        'abortion',
        'Aborto',
        'assets/images/events-abortion-icon.png',
        '#FF6FA0'
    );
    public static readonly MATING = new EventType(
        'mating',
        'Cobertura',
        'assets/images/events-mating-icon.png',
        '#6AAC1C'
    );
    public static readonly CHILDBIRTH = new EventType(
        'childbirth',
        'Parto',
        'assets/images/events-childbirth-icon.png',
        '#F6B240'
    );
    public static readonly SUGGEST_CHILDBIRTH = new EventType(
        'suggest_childbirth',
        'Lançar Parto',
        'assets/images/events-childbirth-icon.png',
        '#F6B240'
    );
    public static readonly DRY = new EventType(
        'dry',
        'Secagem',
        'assets/images/events-dry-icon.png',
        '#0263FF'
    );
    public static readonly CHOOSE_EVENT = new EventType(
        'choose_event',
        'Animal sem Produção',
        'assets/images/events-dry-icon.png',
        '#0263FF'
    );
    public static readonly HERDOUT = new EventType(
        'herdout',
        'Saída de Rebanho',
        'assets/images/events-herdout-icon.png',
        '#BDBDBD'
    );
    public static readonly PREGNANCY = new EventType(
        'pregnancy',
        'Prenhez',
        'assets/images/events-pregnancy-icon.png',
        '#C366D0'
    );
    public static readonly NEW = new EventType(
        'new',
        'Novo',
        null,
        '#e3c923'
    );
    public static readonly MILKED_ANIMAL = new EventType(
        'milked_animal',
        'Ordenha',
        null,
        '#e3c923'
    );
    public static readonly INCOMPLETE = new EventType(
        'incomplete',
        'Cadastro Incompleto',
        null,
        '#F48225'
    );

    public constructor(
        public readonly name: string,
        public readonly label: string,
        public readonly iconPath: string,
        public readonly backgroundColor: string
    ) { }

    public static get(name: string): EventType {
        const eventType = Object.values(EventType).find(it => it.name === name);
        if (eventType == null) {
            throw new Error(`['${name}'] is not a mapped EventType`);
        }
        return eventType;
    }
}
